import React from 'react';
import { Icon } from '@chakra-ui/react';

export const PlayIcon = (props) => {
  return (
    <Icon viewBox="0 0 24 24" role="img" aria-label="Video" {...props}>
      <circle cx="12" cy="12" r="11" fill="currentColor" />
      <path d="M9.5 7.5v9l7-4.5z" fill="white" />
    </Icon>
  );
};
